export default __webpack_public_path__ + "static/media/Dewey-Panic-Grass_L1.127da228.png";